import { Card, CardTitle, Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ParcelDetailPageSkeleton = () => {
  return (
    <Styles.Container>
      <Styles.Header>
        <Styles.NavRow>
          <Skeleton variant="rounded" width={140} height={20} />
          <Styles.NavContainer>
            <Skeleton variant="rounded" width={70} height={20} />
            <Skeleton variant="rounded" width={50} height={20} />
          </Styles.NavContainer>
        </Styles.NavRow>
        <Styles.HeaderOptions>
          <Styles.HeaderOptionsLeft>
            <Skeleton variant="text" width={70} height={28} />
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="rounded" width={80} height={24} />
            <Skeleton variant="rounded" width={100} height={24} />
          </Styles.HeaderOptionsLeft>
          <Styles.HeaderActions>
            <Skeleton variant="rounded" width={120} height={32} />
            <Skeleton variant="rounded" width={140} height={32} />
          </Styles.HeaderActions>
        </Styles.HeaderOptions>
      </Styles.Header>

      <Skeleton variant="rounded" width="100%" height={64} />

      <Styles.MainContainer>
        <Styles.ColumnContainer>
          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={140} height={24} />
            </CardTitle>
            <Styles.StatusContent>
              <Skeleton variant="rounded" width="100%" height={56} />
              <Styles.StatusSteps>
                <Styles.StatusStep>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Skeleton variant="text" width={60} height={14} />
                  <Skeleton variant="text" width={80} height={12} />
                </Styles.StatusStep>
                <Styles.StatusStep>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Skeleton variant="text" width={60} height={14} />
                  <Skeleton variant="text" width={80} height={12} />
                </Styles.StatusStep>
                <Styles.StatusStep>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Skeleton variant="text" width={60} height={14} />
                  <Skeleton variant="text" width={80} height={12} />
                </Styles.StatusStep>
                <Styles.StatusStep>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Skeleton variant="text" width={60} height={14} />
                  <Skeleton variant="text" width={80} height={12} />
                </Styles.StatusStep>
              </Styles.StatusSteps>
            </Styles.StatusContent>
          </Card>

          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={160} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
            </CardTitle>
            <Styles.InfoBlocks>
              <Styles.Info>
                <Skeleton variant="text" width={100} height={14} />
                <Skeleton variant="rounded" width={220} height={20} />
                <Skeleton variant="rounded" width={180} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={80} height={14} />
                <Skeleton variant="rounded" width={200} height={20} />
                <Skeleton variant="rounded" width={160} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={120} height={14} />
                <Skeleton variant="rounded" width={140} height={20} />
              </Styles.Info>
            </Styles.InfoBlocks>
          </Card>

          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={100} height={24} />
            </CardTitle>
            <Styles.ItemsContainer>
              <Styles.LineItem>
                <Skeleton variant="rounded" width={64} height={64} />
                <Styles.ProductInfo>
                  <Skeleton variant="text" width={180} height={20} />
                  <Skeleton variant="text" width={100} height={14} />
                  <Skeleton variant="rounded" width={80} height={20} />
                </Styles.ProductInfo>
              </Styles.LineItem>
              <Styles.LineItem>
                <Skeleton variant="rounded" width={64} height={64} />
                <Styles.ProductInfo>
                  <Skeleton variant="text" width={160} height={20} />
                  <Skeleton variant="text" width={100} height={14} />
                  <Skeleton variant="rounded" width={80} height={20} />
                </Styles.ProductInfo>
              </Styles.LineItem>
            </Styles.ItemsContainer>
          </Card>

          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={100} height={24} />
            </CardTitle>
            <Styles.TimelineContent>
              <Styles.CommentRow>
                <Skeleton variant="circular" width={32} height={32} />
                <Styles.CommentInput>
                  <Skeleton variant="rounded" width="100%" height={32} />
                </Styles.CommentInput>
                <Skeleton variant="circular" width={24} height={24} />
              </Styles.CommentRow>
              <Divider />
              <Skeleton variant="text" width={60} height={14} />
              <Styles.TimelineEvents>
                <Styles.TimelineEvent>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Styles.TimelineEventText>
                    <Skeleton variant="text" width={180} height={16} />
                    <Skeleton variant="text" width={80} height={12} />
                  </Styles.TimelineEventText>
                </Styles.TimelineEvent>
                <Styles.TimelineEvent>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Styles.TimelineEventText>
                    <Skeleton variant="text" width={150} height={16} />
                    <Skeleton variant="text" width={80} height={12} />
                  </Styles.TimelineEventText>
                </Styles.TimelineEvent>
              </Styles.TimelineEvents>
            </Styles.TimelineContent>
          </Card>
        </Styles.ColumnContainer>

        <Styles.ColumnContainer>
          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={160} height={24} />
            </CardTitle>
            <Styles.InfoBlocks>
              <Styles.Info>
                <Skeleton variant="text" width={120} height={14} />
                <Skeleton variant="rounded" width={140} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={100} height={14} />
                <Skeleton variant="rounded" width={120} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={80} height={14} />
                <Skeleton variant="rounded" width={100} height={20} />
              </Styles.Info>
            </Styles.InfoBlocks>
          </Card>

          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={140} height={24} />
            </CardTitle>
            <Styles.InfoBlocks>
              <Styles.Info>
                <Skeleton variant="text" width={80} height={14} />
                <Skeleton variant="rounded" width={160} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={50} height={14} />
                <Skeleton variant="rounded" width={200} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={70} height={14} />
                <Skeleton variant="rounded" width={180} height={20} />
                <Skeleton variant="rounded" width={140} height={20} />
              </Styles.Info>
            </Styles.InfoBlocks>
          </Card>

          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={130} height={24} />
            </CardTitle>
            <Styles.InfoBlocks>
              <Styles.CostRow>
                <Skeleton variant="text" width={80} height={16} />
                <Skeleton variant="rounded" width={60} height={16} />
              </Styles.CostRow>
              <Styles.CostRow>
                <Skeleton variant="text" width={100} height={16} />
                <Skeleton variant="rounded" width={60} height={16} />
              </Styles.CostRow>
              <Styles.CostRow>
                <Skeleton variant="text" width={70} height={16} />
                <Skeleton variant="rounded" width={60} height={16} />
              </Styles.CostRow>
              <Divider />
              <Styles.CostRow>
                <Skeleton variant="text" width={60} height={18} />
                <Skeleton variant="rounded" width={80} height={18} />
              </Styles.CostRow>
            </Styles.InfoBlocks>
          </Card>

          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={100} height={24} />
            </CardTitle>
            <Styles.Info>
              <Skeleton variant="text" width={70} height={14} />
              <Styles.FileRow>
                <Skeleton variant="circular" width={20} height={20} />
                <Skeleton variant="rounded" width={220} height={20} />
                <Skeleton variant="circular" width={20} height={20} />
              </Styles.FileRow>
              <Styles.FileRow>
                <Skeleton variant="circular" width={20} height={20} />
                <Skeleton variant="rounded" width={200} height={20} />
                <Skeleton variant="circular" width={20} height={20} />
              </Styles.FileRow>
            </Styles.Info>
          </Card>
        </Styles.ColumnContainer>
      </Styles.MainContainer>
    </Styles.Container>
  )
}

export default ParcelDetailPageSkeleton
